enum KeySkillGrade {
    NOT_STARTED="#000000",
    JUST_STARTED="#FF5050",
    MEDIUM="#FAD223",
    HIGH="#94C83D",
}

export default KeySkillGrade;
